import { SegmentStrategy } from "../rules/intoSegments";
import { RuleSet } from "../rules/ruleSet";

/**
 * International Alphabet of Sanskrit Transliteration (IAST),
 * a Latin alphabet sometimes used for transliteration of Sanskrit & related Indic languages
 * https://en.wikipedia.org/wiki/International_Alphabet_of_Sanskrit_Transliteration
 * plus ISO 15919, which is close
 * https://en.wikipedia.org/wiki/Devanagari_transliteration
 */
export const sanskritTransliteration: RuleSet = {
  preprocess: ['cleanPunctuation', 'lowerCase'],
  inputSegments: SegmentStrategy.Single,
  sortRulesByInputLength: true,
  rules: [ // ISO 15919 -> IAST
    { from: 'r̥', to: 'ṛ' },
    { from: 'r̥̄', to: 'ṝ' },
    { from: 'l̥', to: 'ḷ' },
    { from: 'l̥̄', to: 'ḹ' },
    { from: 'ē', to: 'e' },
    { from: 'ō', to: 'o' },
    { from: 'ṁ', to: 'ṃ' },
  ],
  rules2: [ // IAST -> IPA
    { from: 'ai', to: 'ɐːi̯' },
    { from: 'au', to: 'ɐːu̯' },
    { from: 'a', to: 'ɐ' },
    { from: 'ā', to: 'aː' },
    { from: 'i', to: 'ɪ' },
    { from: 'ī', to: 'iː' },
    { from: 'u', to: 'ʊ' },
    { from: 'ū', to: 'uː' },
    { from: 'ṛ', to: 'r̩' },
    { from: 'ṝ', to: 'r̩ː' },
    { from: 'ḷ', to: 'l̩' },
    { from: 'ḹ', to: 'l̩ː' },
    { from: 'e', to: 'eː' },
    { from: 'o', to: 'oː' },

    { from: 'ph', to: 'pʰ' },  // aspirated
    { from: 'th', to: 't̪ʰ' },
    { from: 'ṭh', to: 'ʈʰ' },
    { from: 'ch', to: 'cʰ' },
    { from: 'kh', to: 'kʰ' },
    { from: 'p', to: 'p' },   // unaspirated
    { from: 't', to: 't̪' },
    { from: 'ṭ', to: 'ʈ' },
    { from: 'c', to: 'c' },
    { from: 'k', to: 'k' },
    { from: 'bh', to: 'b̤' },   // breathy-voiced
    { from: 'dh', to: 'd̪̤' },
    { from: 'ḍh', to: 'ḍ̤' },
    { from: 'jh', to: 'ɟ̤' },
    { from: 'gh', to: 'g̤' },
    { from: 'b', to: 'b' },    // voiced
    { from: 'd', to: 'd̪' },
    { from: 'ḍ', to: 'ɖ' },
    { from: 'j', to: 'ɟ' },
    { from: 'g', to: 'g' },
    { from: 'm', to: 'm' },    // nasal
    { from: 'n', to: 'n̪' },
    { from: 'ṇ', to: 'ɳ' },
    { from: 'ñ', to: 'ɲ' },
    { from: 'ṅ', to: 'ŋ' },
    { from: 'v', to: 'v' },    // approximants
    { from: 'l', to: 'l̪' },
    { from: 'ḻ', to: 'ɭ' },
    { from: 'r', to: 'ɽ' },
    { from: 'y', to: 'j' },
    { from: 'h', to: 'h' },
    { from: 's', to: 's̪' },   // sibilants
    { from: 'ṣ', to: 'ʂ' },
    { from: 'ś', to: 'ʃ' },

    { from: 'ṃ', to: 'm' },  // anusvara
    { from: 'ḥ', to: 'ᵊ̯' },  // visarga
    { from: '˜', to: '\u0303' },  // chandrabindu[3]
    { from: "'", to: 'ː' }, { from: "´", to: 'ː' },  // avagraha
  ],

  stressRule: { default: -1 }
}
